import Modal from "components/modal/modal";
import styled from "styled-components";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { CustomTNFeInfNFeDetProdDetExport } from "./ItemModal";
import { toast } from "react-toastify";

const ItemModalFrame = styled.div`
        top: 6px;
        left: -14px;
        width: 100%;
        position: absolute;
        z-index: 10000;

        .modal-body {
            padding: 15px;
            overflow: scroll;
        }
`;

interface ItemModalProps {
    onSave: (det: CustomTNFeInfNFeDetProdDetExport) => void
    handleClose: Function
    detExport: CustomTNFeInfNFeDetProdDetExport
}

export function DetExportModal({ onSave, handleClose, detExport }: ItemModalProps) {

    const { handleSubmit, register, reset, formState: { errors } } = useForm<CustomTNFeInfNFeDetProdDetExport>({
        defaultValues: { id: null, ndraw: null, exportInd: { chNFe: '', nre: '', qexport: '' } },
        shouldUnregister: true
    });

    function onSubmit(form: CustomTNFeInfNFeDetProdDetExport) {
        onSave(form);
    }

    const actionButtons = [{
        text: 'Cancelar',
        actionCallback: () => handleClose(),
        positiveAction: false
    },
    {
        text: 'Confirmar',
        actionCallback: () => handleSubmit(onSubmit, handleError)(),
        positiveAction: true
    }];

    function handleError() {
        if (errors?.exportInd) {
            toast.warn(errors?.exportInd.nre?.message);
            return;
        }
        if (errors?.ndraw?.message) {
            toast.warn(errors?.ndraw?.message);
            return;
        }
    }

    useEffect(() => {
        reset(detExport);
    }, [detExport]);

    return (
        <ItemModalFrame>
            <Modal headerTitle={detExport?.id ? "Editar Detalhe da exportação" : "Criar Detalhe da exportação"} closeOnClickAway={true} handleClose={handleClose} loading={false} actionButtons={actionButtons}>
                <div className="edit-frame">
                    <aside className={['bottom-frame', 'edit-border', 'visible'].join(' ')}>
                        <div className="content" style={{ minHeight: 180 }}>
                            <form style={{ minWidth: 500 }} key={detExport?.id}>
                                <input type="hidden" {...register("id")} />
                                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Número do ato concessório de Drawback</span>
                                        <input type="text" {...register("ndraw", { minLength: 1, maxLength: 20 })} />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Registro de exportação</span>
                                        <input type="text" {...register("exportInd.nre", {
                                            pattern: {
                                                value: /^[0-9]{0,12}$/,
                                                message: 'Registro de exportação deve ser entre 1 e 12 dígitos numéricos',
                                            },
                                        })} />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Chave de acesso da NF-e recebida para exportação</span>
                                        <input type="text" {...register("exportInd.chNFe")} />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Quantidade do item efetivamente exportado</span>
                                        <input type="text" {...register("exportInd.qexport")} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </aside>
                </div>
            </Modal>
        </ItemModalFrame>
    );
}